<template>
  <div>
    <v-row dense no-gutters>
      <v-col md="12">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <autocompletar v-model="buscado"></autocompletar>
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense no-gutters>
      <v-col md="12">
        <Administrar
          deshabilitar
          titulo="Consulta de datos"
          readonly
          v-if="Seleccionado && Seleccionado.id_afiliado != 0"
        ></Administrar>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Administrar from '@/components/Beneficiarios/Administrar.vue'
import autocompletar from '@/components/Beneficiarios/AutoNombreDNINroAfi'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Beneficiarios',
  data: function () {
    return {
      buscado: undefined
    }
  },
  components: {
    Administrar,
    autocompletar
  },
  computed: {
    ...mapState('beneficiarios', ['Lista', 'Seleccionado'])
  },
  methods: {
    ...mapActions('beneficiarios', ['select'])
  },
  watch: {
    buscado() {
      this.select(this.buscado)
    }
  }
}
</script>
<style></style>
